import {
  Body,
  Column,
  column,
  HeaderActions,
  HeaderButton,
  HeaderLeading,
  HeaderTitle,
  READING_WIDTH,
  TOP_PADDING,
} from './page.parts';
import { PanelTitle } from './side-panel.parts';

export const Page = {
  Title: PanelTitle,
  Body,
  Column,
  column,
  HeaderActions,
  HeaderButton,
  HeaderLeading,
  HeaderTitle,
  readingWidth: READING_WIDTH,
  topPadding: TOP_PADDING,
};
